import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const StudentEmailSms = lazyRouteComponent(() => import('@/_instructor/customer-profile/email-sms'));

export const Route = createFileRoute('/_instructor/student/sms')({
  component: () => renderInstructorPage(StudentEmailSms),
});
